module.exports = __webpack_public_path__ + "static/img/company.86ab0cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/company.jpg
// module id = w2oO
// module chunks = 0